import type { LeadsSearchRow } from "app/pages/sales-intelligence/modules/leads-search";
import { getLeadDomainFromRow } from "app/pages/sales-intelligence/modules/leads-search/utils/rows";
import type { TabName } from "app/pages/sales-intelligence/sub-modules/account-overview/company/types/tabs";
import {
    createAccountOverviewLink,
    createSignalTypeLink,
} from "app/pages/sales-intelligence/sub-modules/account-overview/shared/helpers/routing";

interface IGetCompanyOverviewLinkProps<T> {
    record: T;
    activePageSection?: TabName;
}

export const getCompanyOverviewLink = <T extends LeadsSearchRow>({
    record,
    activePageSection,
}: IGetCompanyOverviewLinkProps<T>) => {
    const leadDomain = getLeadDomainFromRow(record);
    return {
        redirectLink: createAccountOverviewLink(leadDomain)(activePageSection),
        getSignalTypeLink: createSignalTypeLink(leadDomain),
    };
};
